import {createSlice} from '@reduxjs/toolkit';
import download from '../../../util/DownloadLink';
import {httpPost, httpGet} from '../../../util/Rest';
// import { OPERATOR } from "../../../constants/Lookup";

const initialData = {
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  filterGroupDataStatus: null,
  filterGroupData: {},
  addNoteStatus: null,
};

const slice = createSlice({
  name: 'FilterGroup',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.addNoteStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postFilterGroupData: (state, action) => {
      state.filterGroupDataStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getFieldGroupData: (state, action) => {
      state.filterGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.filterGroupDataStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    notesresetStatus: (state, action) => {
      state.addNoteStatus = null;
      state.isLoading = false;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.printStatus = null;
    },
    resetStatus: (state, action) => {
      state.filterGroupDataStatus = null;
      state.isLoading = false;
      state.filterGroupData = {};
    },
    printSuccess: (state, action) => {
      state.printStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchError,
  getFieldGroupData,
  postFilterGroupData,
  resetStatus,
  postSystemNotesData,
  notesresetStatus,
  resetMessage,
  printSuccess,
} = slice.actions;

export const saveFilterGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('enableintegration/save/filtergroup', details)
      .then((data) => {
        if (data && data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data?.status === 200) {
          dispatch(postFilterGroupData(data));
        }
      })
      .catch((error, data) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFilterGroup = (filterGroupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`enableintegration/find/filtergroup/${filterGroupId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFieldGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const AddNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/save/filtergroup/notes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const NoteResetStatus = () => {
  return (dispatch) => {
    dispatch(notesresetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const postFilterGroup = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/print/enablefiltergroup`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printFilterGroup({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const printFilterGroup = (payload, printData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/generateurlprintenablefiltergroup`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printSuccess(printData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
